export default "__VITE_ASSET__ClMDoywH__"